import clsx from "clsx"
import Link from "next/link"

interface TagProps {
  title: string
  href: string
  isActive?: boolean
}

export default function Tag({title, href, isActive=false}:TagProps) {
  return (
    <Link
      className={clsx('px-[12px] pt-[4px] pb-[6px] md:px-[18px] md:pt-[6px] md:pb-[8px] rounded-full border border-solid style-tag md:style-tag--lg text-black hover:border-blue', isActive ? 'border-black' : 'border-black/20')}
      href={href}
      scroll={false}
    >
      {title}
    </Link>
  )
}